import HttpClient from "libs/utils/HttpClient";

class TransferJobService {


  async getTransferJob() {
    try {


      const response = await HttpClient.get(`/api/visaformadmin/employee/joblist`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getTransferJobDetail(body) {
    try {


      const response = await HttpClient.post(`/api/visaformadmin/employee/joblist/detail`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async transferJobs(body) {
    try {


      const response = await HttpClient.post(`/api/visaformadmin/smartfrom/transfersjob`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



}

export default new TransferJobService();

